import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";

const ReportFiltersMonthDate = ({
  monthYearList,
  selectMonthYear,
  setSelectMonthYear,
  handleExport,
}) => {
  const [openMonth, setOpenMonth] = useState(false);

  // Handle selection of month-year
  const handleMonthChange = (event, newValue) => {
    setSelectMonthYear(newValue); // Update selected months
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography variant="h5" sx={{ color: "#333", fontWeight: "bold" }}>
          Search Filters
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            sx={{
              color: "green",
              borderColor: "green",
              "&:hover": { backgroundColor: "rgba(0, 128, 0, 0.1)" },
            }}
            startIcon={<IosShareIcon />}
            onClick={() => handleExport("excel", "stock")}
          >
            Export to Excel
          </Button>
          <Button
            variant="outlined"
            sx={{
              color: "#A52A2A",
              borderColor: "#A52A2A",
              "&:hover": { backgroundColor: "rgba(165, 42, 42, 0.1)" },
            }}
            startIcon={<IosShareIcon />}
            onClick={() => handleExport("pdf", "stock")}
          >
            Export to PDF
          </Button>
        </Stack>
      </Box>

      <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ p: 2 }}>
        {/* Month - Year Filter */}
        <Box sx={{ minWidth: { xs: 250, md: 300 } }}>
          <FormControl fullWidth>
            <Autocomplete
              multiple
              open={openMonth}
              onOpen={() => setOpenMonth(true)}
              onClose={() => setOpenMonth(false)}
              options={monthYearList} // Month-Year list (e.g., ["JANUARY 2025", "FEBRUARY 2025"])
              value={selectMonthYear} // Selected month-year(s)
              onChange={handleMonthChange} // Handle month change
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Month - Year"
                  placeholder="Select Month - Year"
                  variant="outlined"
                  sx={{ borderRadius: "8px" }}
                />
              )}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox checked={selected} />
                  {option} {/* Display month-year */}
                </li>
              )}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            variant="contained"
            sx={{
              minWidth: 150,
              minHeight: 45,
              backgroundColor: "#6c757d",
              color: "white",
              "&:hover": { backgroundColor: "#5a6268" },
              borderRadius: "8px",
              boxShadow: 2,
            }}
            onClick={() => setSelectMonthYear([])} // Clear selected month-year(s)
          >
            Clear Filters
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default ReportFiltersMonthDate;
